import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { verifyResetCode } from '../api/Authapi';
import './VerifyResetCode.css';
import logo from '../assets/logo.png';

const VerifyResetCode = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;
  
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Redirect if no email provided
  useEffect(() => {
    if (!email) {
      navigate('/forgot-password'); 
    }
  }, [email, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const response = await verifyResetCode(email, code);
      setSuccess(response.data.message);
      
      // Navigate to reset password page after verification
      setTimeout(() => {
        navigate('/reset-password', { state: { email, code } });
      }, 1000);
    } catch (err) {
      setError(err.response?.data?.message || 'Invalid code. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleCodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Only allow digits
    if (value.length <= 6) {
      setCode(value);
    }
  };

  return (
    <div className='verify-code-form-container'>
      <form className='verify-code-form' onSubmit={handleSubmit}>
        <div>
          <h3>Verify Reset Code</h3>
          <p>We've sent a 6-digit code to <strong>{email}</strong>. Enter it below to proceed.</p>
        </div>

        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}

        <div className="input-container">
          <label htmlFor="code">Reset Code</label>
          <input 
            type="text"
            className="form-input code-input"
            id="code" 
            name="code"
            value={code}
            onChange={handleCodeChange}
            placeholder="Enter 6-digit code" 
            maxLength={6}
            required
          />
          <small>Code expires in 15 minutes</small>
        </div>

        <button type="submit" className="verify-code-form-button" disabled={loading || code.length !== 6}>
          {loading ? 'Verifying...' : 'Verify Code'}
        </button>

        <div className="navigation-links">
          <button 
            type="button" 
            onClick={() => navigate('/forgot-password')} 
            className="link-button"
          >
            Resend Code
          </button>
          <button 
            type="button" 
            onClick={() => navigate('/login')} 
            className="link-button"
          >
            Back to Login
          </button>
        </div>
      </form>
    </div>
  );
};

export default VerifyResetCode;